import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "brief-info"
};
const _hoisted_2 = {
  class: "mct-blue"
};
const _hoisted_3 = ["href"];
export default /*@__PURE__*/_defineComponent({
  __name: 'CheckNameAndOwner',
  props: {
    checkName: {},
    clusterName: {
      default: ''
    },
    clusterId: {
      default: ''
    },
    currServerId: {}
  },
  setup(__props) {
    const getCheckName = str => {
      const nameRegex = /(.+)\((.+)\)/;
      if (nameRegex.test(str)) {
        const res = nameRegex.exec(str);
        if (res?.[1] && res?.[2] && res?.[1] === res?.[2]) {
          return res?.[1];
        }
      }
      return str;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("h1", null, "Check Status Detail", -1)), _createElementVNode("h1", _hoisted_2, _toDisplayString(getCheckName(_ctx.checkName)), 1), _cache[2] || (_cache[2] = _createElementVNode("span", null, "(Cluster:", -1)), _createElementVNode("a", {
        class: "mct-blue pointer",
        href: '/cluster-status/' + _ctx.clusterId,
        target: "_blank",
        rel: "opener"
      }, [_createTextVNode(_toDisplayString(_ctx.clusterName) + " ", 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "mct-black"
      }, ")", -1))], 8, _hoisted_3)]);
    };
  }
});